module.exports = __webpack_public_path__ + "static/media/KLLogo2.ede8531e.png";